import React, { useMemo } from 'react';
import { classNames } from '../../CodesThatsGottaGoSomewhereElse';
import { toRem } from '../../ui';
import { Fauxdown } from './Fauxdown';
import { FormattingOptionItem } from './FormattingOptionItem';

export interface FauxCopyProps {
    align?: 'left' | 'center' | 'right';
    wordBreak?: 'break-word' | 'normal' | 'break-all' | 'break-initial';
    bold?: boolean;
    bolder?: boolean;
    color?: string;
    em?: boolean;
    flush?: boolean;
    strike?: boolean;
    size?: string | number;
    lineHeight?: string | number;
    value: string;
}

export const FauxCopy = ({ value, ...props }: FauxCopyProps) => {
    value = value || '';
    // eslint-disable-next-line no-underscore-dangle
    const __html = useMemo(() => Fauxdown.toEditorForm(value, FormattingOptionItem.all), [value]);
    const style = {
        wordBreak: props.wordBreak ?? 'inherit' as any,
        textAlign: props.align ?? 'inherit' as any,
        color: props.color ?? 'inherit',
        fontSize: toRem(props.size || 1),
        fontStyle: props.em ? 'italic' : 'initial',
        fontWeight: props.bold ? '450' : (props.bolder ? '550' : 'initial'),
        textDecoration: props.strike ? 'line-through' : 'initial',
        lineHeight: props.lineHeight || '1.5em'
    };

    return <div {...classNames('ql-text')} style={style} dangerouslySetInnerHTML={{ __html }} />;
};
